import Vue from 'vue'
import EmpDialogSelector from './emp-dialog-selector.vue'
import EmpDialogSelectorInstance from './emp-dialog-selector-instance.vue'


EmpDialogSelector.install = function (Vue) {
	Vue.component(EmpDialogSelector.name, EmpDialogSelector);
}

export default EmpDialogSelector;

class EmpInstance {
	constructor() {
		this.instance = null;
	}
	init() {
		// 初始化实例，挂载dom
		const VueInstance = Vue || window.Vue;
		let EmpComponent = VueInstance.extend(EmpDialogSelectorInstance);
		this.instance = new EmpComponent({
			el: document.createElement('div'),
		}).$mount();
		document.body.appendChild(this.instance.$el);
	}
	getInstance() {
		// 返回实例
		return this.instance;
	}	
	// 外部调用方法
	show(params) {
		return new Promise((resolve, reject) => {
			if (!this.instance) {
				this.init();
			}
			Object.assign(this.instance, {resolve, reject})
			this.instance.show(params);
		})
		
	}
}


export const EmpSelectModal = new EmpInstance();
window.empSelectModal = EmpSelectModal;